var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m7.223 6.095 10.554-2.068c.664-.13 1.223.221 1.223.79v9.313c0 .57-.548 1.136-1.223 1.269l-1.765.346v3.527c0 .52-.47.832-1.053.696l-7.906-1.84C6.47 17.994 6 17.464 6 16.943V7.363c0-.569.548-1.136 1.223-1.268m6.81 7.633-4.791.852a.67.67 0 0 1-.783-.522.65.65 0 0 1 .54-.757l4.79-.852a.67.67 0 0 1 .783.522.65.65 0 0 1-.54.757m-4.834-1.88 7.095-1.262a.65.65 0 0 0 .54-.757.67.67 0 0 0-.783-.521l-7.095 1.26a.65.65 0 0 0-.54.757.67.67 0 0 0 .783.522m7.062-3.937-7.095 1.26a.67.67 0 0 1-.783-.521.65.65 0 0 1 .54-.757l7.095-1.26a.67.67 0 0 1 .782.521.65.65 0 0 1-.54.757M14.216 18.04v-1.946l-4.451.88z",
  clipRule: "evenodd"
})));
export default SvgGemChannelPrint;